<ion-list no-lines>
  <ion-item class="list-item-header">
    <span>{{header}}</span>
    <button (click)="closeList()" style="background: none">
      <monorepo-zf-icon [iconName]="'cross'" [iconClasses]="['zf-list-cross']"></monorepo-zf-icon>
    </button>
  </ion-item>
  <ion-item
    *ngFor="let item of items; let i = index; first as isFirst; last as l"
    (click)="changeActiveIndex(i)"
    class="list-item"
    [ngStyle]="{ 'padding-top' : isFirst ? '18px' : '10px', 'padding-bottom': l ? '24px' : '0px' }"
  >
    <ion-col size="10" class="ion-no-padding">
      <div
        *ngFor="let object of item; last as isLast; first as objFirst"
        [ngClass]="{'item-value-last': isLast && !objFirst, 'item-value':!isLast || objFirst, 'object.class': object.class }"
      >
        {{object.value}}
      </div>
    </ion-col>
    <ion-col
      class="selector-icon"
      *ngIf="i === currentActiveIndex; else circle_template"
      size="2"
      class="ion-no-padding"
    >
      <monorepo-zf-icon [iconName]="'radio'" [iconClasses]="['zf-list-radio', 'zf-icon--size-xl']"></monorepo-zf-icon>
    </ion-col>
  </ion-item>
</ion-list>

<ng-template #circle_template>
  <div class="hollow-circle"></div>
</ng-template>
